module.exports = __webpack_public_path__ + "7b694d077633d337f1fb8d5e6dc7a64a.woff";


//////////////////
// WEBPACK FOOTER
// ./markup/fonts/roboto/roboto-bold.woff
// module id = 1132
// module chunks = 0